import React from "react";
import { useTranslation } from "react-i18next";

const TransactionConfirm = (props) => {
  const { t } = useTranslation();
  return (
    <div className="transaction-wrapper">
      <div className="msg-wrapper">
        <div className="trans-msg">
          <span>{t("user.order.transactionSuccessful")}</span></div>
        <div className="trans-msg">
        <span>{props?.message || t("user.transaction.collectFromCounter")}</span>
        </div>
      </div>
      <button className="transaction-btn" onClick={props?.callBasicApi}>{t("common.close")}</button>
    </div>
  );
};

export default TransactionConfirm;
//
